import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const orderId = params.get("orderId");

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2 style={styles.title}>❌ Payment Failed</h2>
        <p style={styles.text}>
          Unfortunately your payment could not be completed.
        </p>

        {orderId && (
          <p style={styles.small}>
            Order ID: <strong>{orderId}</strong>
          </p>
        )}

        <div style={styles.actions}>
          <button onClick={() => navigate("/services")} style={styles.retryBtn}>
            Re-Book
          </button>
          <button onClick={() => navigate("/")} style={styles.homeBtn}>
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9d893",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "420px",
    width: "100%",
  },
  title: {
    color: "#e74c3c",
    marginBottom: "10px",
  },
  text: {
    color: "#555",
  },
  small: {
    fontSize: "14px",
    color: "#777",
    marginTop: "10px",
  },
  actions: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  retryBtn: {
    flex: 1,
    background: "#ff9f43",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
  },
  homeBtn: {
    flex: 1,
    background: "#636e72",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
  },
};

export default PaymentFailure;
